<template>
    <div>
        <TableActionHeader ref="actionHeader" 
            @filterChange="onFilterChange" 
            :selectOptions="usageOptions" 
            @filterSelect="onUsageSelect"
            :selected="usageFilter"
            :selectOptions2="orientationOptions" 
            @filterSelect2="onOrientationSelect"
            :selected2="orientationFilter"
            > 
        </TableActionHeader>
        
        <b-table ref="table"
            responsive="sm" 
            striped hover 
            selectable 
            select-mode="single" 
            @row-selected="onRowSelected"
            :items="layoutList"
            sort-by="usage" 
            :sort-desc="true"
            :fields="fields" 
            :small="true" 
            :per-page="perPage" 
            :current-page="currentPage"
            :filter="filter"
            @filtered="onFiltered" 
            :busy="loading">
            <template #table-busy>
                <Loading />
            </template>
             <template v-slot:cell(usage)="data">
                <b-badge pill variant="warning">{{ data.item.usage }}</b-badge>
             </template>
        </b-table>
        <TablePagination 
            :total-rows="totalRows" 
            :per-page="perPage" 
            @pageChange="onPageChange">
        </TablePagination>
    </div>
</template>

<script>

import layout from '@/store/displays/layout'
import infopoint from '@/store/displays/infopoint'

export default {
    props: ['item'],
    data: function () {
        return {
            perPage: 15,
            currentPage: 1,
            filteredRows: 1,
            filteredLayouts: [],
            filter: "",
            loading: true,
            usageFilter: "IN_USE",
            usageOptions: [
                { id: 'ALL', label: this.$t("filter.no"), icon: 'filter', caption: this.$t("infopointlayouts.usage.label") },
                { id: 'IN_USE', label: this.$t('infopointlayouts.usage.in_use'), icon: 'check-square-fill', variant: 'success' },
                { id: 'NOT_IN_USE', label: this.$t('infopointlayouts.usage.not_in_use'), icon: 'dash-square-fill', variant: 'danger' },
            ],
            orientationFilter: "ALL",
            orientationOptions: [
                { id: 'ALL', label: this.$t("filter.no"), icon: 'filter', caption: this.$t("infopointlayouts.orientation.label") },
                { id: 'HORIZONTAL', label: this.$t('infopointlayouts.orientation.HORIZONTAL'), icon: 'arrow-left-right' },
                { id: 'VERTICAL', label: this.$t('infopointlayouts.orientation.VERTICAL'), icon: 'arrow-down-up' },
                { id: 'RESPONSIVE', label: this.$t('infopointlayouts.orientation.RESPONSIVE'), icon: 'asterisk' },
            ]
        }
    },
    watch: {
        orientationFilter() {
            this.currentPage = 1;
        },
        item() {
            if (!this.item)
                this.$refs.table.clearSelected();

        }
    },
    computed: {
        layoutList() {
            const self = this;
            var layouts = this.$store.state.layout.layouts;
            if(this.usageFilter != 'ALL'){
                let filtered = [];
                layouts.forEach(function (layout) {
                    if(self.usageFilter == "IN_USE" && layout.usage > 0) filtered.push(layout);
                    if(self.usageFilter == "NOT_IN_USE" && layout.usage == 0) filtered.push(layout);
                });
                layouts = filtered;
            }

            if(this.orientationFilter != 'ALL'){
                let filtered = [];
                layouts.forEach(function (layout) {
                    if(self.orientationFilter == layout.orientation)
                        filtered.push(layout);
                });
                layouts = filtered;
            }

            return layouts;
        },
        fields() {
            return [
                { key: "name", label: this.$t('infopointlayouts.name'), sortable: true },
                { key: "orientation", label: this.$t('infopointlayouts.orientation.label'), sortable: true, formatter: 'getOrientation' },
                { key: "resolution", label: this.$t('infopointlayouts.resolution'), sortable: true, formatter: 'getResolution' },
                { key: "rows", label: this.$t('infopointlayouts.rows'), sortable: true },
                { key: "usage", label: this.$t('infopointlayouts.usage.label'), sortable: true },
            ];
        },
        totalRows() {
            if (!this.filter) {
                return this.layoutList.length;
            }
            return this.filteredRows;
        },
    },
    beforeCreate: function () {
        if (!this.$store.state.layout) this.$store.registerModule("layout", layout)
        if (!this.$store.state.infopoint) this.$store.registerModule("infopoint", infopoint);

        const p1 = this.$store.dispatch('layout/getLayouts')
        const p2 = this.$store.dispatch('infopoint/getInfopointList')

        this.loading = true;
        Promise.all([p1, p2]).finally(() => {
            this.loading = false;
        });

    },
    created() {
        var status = this.$route.query.status;
        if (status) this.statusFilter = status.toUpperCase();
    },
    mounted() {
        if (this.$route.query.id) {
            this.setFilterValue(this.$route.query.id)
        }
    },
    methods: {
        /*
        filterFunction: function(item) {
            console.log(item.id);
            if(item.width) return true;
            
            return false;
        },
        */

        setFilterValue(newVal) {
            this.$refs.actionHeader.setFilterValue(newVal);
            this.filter = newVal;
        },
        onFilterChange(filter) {
            this.filter = filter;
        },

        onUsageSelect(id) {
            this.usageFilter = id;
        },

        onOrientationSelect(id) {
            this.orientationFilter = id;
        },


        onPageChange(page) {
            this.currentPage = page;
        },
        onFiltered(filteredItems) {
            this.filteredRows = filteredItems.length
            this.currentPage = 1
        },
        onRowSelected(items) {
            if (items[0])
                this.$emit('selectItem', items[0]);
        },
        getOrientation(value, key, item){
            var orientation = "-";
            if(item.orientation)
                orientation =  this.$t('infopointlayouts.orientation.' + item.orientation);   
            
            return orientation;
        },
        getResolution(value, key, item){
            var res = "-";
            if(item.width && item.height)
                res = item.width + " x " + item.height;

            return res;
        }
    }
}
</script>
